import { Stack, SxProps } from "@mui/material";
import { Component } from "react";

interface DetailsGridProps {
  direction?: "row" | "column";
  spacing?: number;
  sx?: SxProps;
  children?: React.ReactNode;
}

export class DetailsGrid extends Component<DetailsGridProps> {
  static defaultProps = {
    direction: "column",
    spacing: 2
  };

  render() {
    const { children, direction, spacing, sx } = this.props;

    return (
      <Stack direction={direction} spacing={spacing} sx={sx}>
        {children}
      </Stack>
    );
  }
}
